import { render, staticRenderFns } from "./WapWXCW01Operate.vue?vue&type=template&id=63085828&scoped=true&"
import script from "./WapWXCW01Operate.vue?vue&type=script&lang=js&"
export * from "./WapWXCW01Operate.vue?vue&type=script&lang=js&"
import style0 from "./WapWXCW01Operate.vue?vue&type=style&index=0&id=63085828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63085828",
  null
  
)

export default component.exports